import Container from '../../../elements/Container'
import Section from '../../../elements/Section'
import styles from './styles.module.scss'
import LineSeparator from '../../../elements/LineSeparator'
import Head from 'next/head'
import { getS3Url } from '../../../helpers/getS3Url'

const Welcome = ({ title, date, image }) => {
  return (
    <>
      {image && (
        <Head>
          <link rel="prefetch" href={image} as="image" type="image/jpeg" />
        </Head>
      )}
      <Section variant={['center', 'pb0', 'bg-body']}>
        <Container variant={['-xl2']}>
          <div className={styles.intro}>
            {title && <h1 className={styles.intro__title}>{title}</h1>}

            <LineSeparator variant={['center']} />

            {date && <div className={styles.intro__subtitle}>{date}</div>}

            {image && (
              <div className={styles.intro__image}>
                <img
                  src={getS3Url(image, '1980')}
                  srcSet={`
                    ${getS3Url(image, '360')} 360w,
                    ${getS3Url(image, '640')} 640w,
                    ${getS3Url(image, '960')} 960w,
                    ${getS3Url(image, '1980')} 1980w
                  `}
                  sizes="100vw"
                  alt={title || 'Blog Post Image'}
                  style={{
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%'
                  }}
                  fetchpriority="high"
                />
              </div>
            )}
          </div>
        </Container>
      </Section>
    </>
  )
}

export default Welcome
